import Vue from 'vue'
import Vuex from 'vuex'

import Operacion from '@/modules/operacion/operacion.module.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: false,
    theme: false,
    domain: {
      domainName: window.location.hostname == "localhost" ? "" : "/Siniestros",
      domainNameWithHttp: window.location.hostname == "localhost" ? 'http://localhost:51758/' : 'https://www.ausa.com.mx/Siniestros/',
      domainNameForApi: window.location.hostname == "localhost" ? 'http://localhost:51758/api/' : 'https://www.ausa.com.mx/Siniestros/api/',
      domainAusa: window.location.hostname == "localhost" ? 'http://localhost:1902' : 'https://www.ausa.com.mx/Siniestros'
    },
    user: new Map(),
    informationPage: {
      expireSession: false,
      nameCookiePGV2: "Siniestros",
      nameLocalStoragePGV2: "Siniestros",
    },
    permission: {
      global: 313,
      single: {
        tablero: 314,
        configuracion: 344,
          bitacora: 327,
          estadistico: 321,
          viales: 355
      }
    }
  },
  mutations: {
    fillDataUser(state, data) {
      state.user.set(state.permission.global, { uslogin: data });
    },
    changeExpireSession(state, data) {
      state.informationPage.expireSession = data;
    },
    toggleDrawer(state) {
      state.drawer = !state.drawer;
    },
    toggleTheme(state, data) {
      state.theme = data;
    },
  },
  actions: {
    setChangeExpireSession({ commit }, data) {
      commit('changeExpireSession', data);
    },
    TOGGLE_DRAWER({ commit }) {
      commit('toggleDrawer');
    },
    TOGGLE_THEME({ commit }, data) {
      commit('toggleTheme', data);
    },
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    DRAWER_STATE(state) {
      return state.drawer;
    },
    THEME_STATE(state) {
      return state.theme;
    },
  },
  modules: {
    Operacion
  }
})
